export class StorageConstants {
  public static readonly ID_PROVIDER = 'idProvider';
  public static readonly PRODUCTS_CART = 'productsCart';
}
